import { useEffect, useState } from 'react';
import { AddProductModal } from './add-product-modal/add-product-modal.component';
import { ProductItem } from './product-item/product-item.component';
import { BusinessStore } from '../../../store/businessStore';
import type { IBusiness } from '@recargas-dominicanas/core/types';
import { style } from './products.module.css';

import { 
  OutlineButton, 
  Text,
  Table,
  TableHeader 
} from '@recargas-dominicanas/core/components';

interface Props {
  business: IBusiness;
}

export function CustomerProducts(props: Props) {

  const { business } = props;

  const [openAddModal, setOpenAddModal] = useState(false);
  const products = BusinessStore.getCustomerProducts(business.id);

  useEffect(() => {
    BusinessStore.fetchCustomerProducts(business.id, business.customerId);
  }, []);

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <Text text='Logo'/>
          <Text text='Nombre'/>
          <Text text='Tipo'/>
          <Text text='Beneficio'/>
          <OutlineButton 
            style={style.addButton} 
            text='Agregar producto'
            onClick={() => setOpenAddModal(true)}/>
        </TableHeader>
        <tbody>
          {
            products?.map(product => (
              <ProductItem
                key={product.id} 
                customerId={business.customerId}
                businessId={business.id}
                customerProduct={product}/>
            ))
          }
        </tbody>
      </Table>
      <AddProductModal
        open={openAddModal}
        customerId={business.customerId}
        businessId={business.id}
        onClose={() => setOpenAddModal(false)}/>
    </div>
  );
}
